export const ITEM_TRANSLATION_MAP: Record<string, string> = {
    designation: "Designation",
    note: "Note",
    ip: "Address IP",
    codeCaisse: "Cash register code",
};

export const OPERATION_LABELS: Record<string, string> = {
    modify: "Modification",
    creation: "Creation",
    Archivage: "Archiving",
    Désarchivage: "Unarchiving",
};

// Cash register code (codeCaisse): exactly 2 digits, value between 01 and 99
// (00 disallowed, single digits disallowed).
export const POS_CODE_CAISSE_LENGTH = 2;
export const POS_CODE_CAISSE_REGEX = /^(0[1-9]|[1-9][0-9])$/;
